module.exports = __webpack_public_path__ + "img/juJiaZhongDian.d48ccbb7.png";